
import axios from 'axios'
//import Cookie from "js-cookie";
//import { resolve, reject } from 'core-js/fn/promise'
//eslint-disable-all

const validStatuses = [
    200, 201, 202, 203, 204,
    300, 301, 302, 303, 304
  ]

function checkResponse({dispatch}, response) {
  if (validStatuses.includes(response.status)) {
    return response;
  }

  // If not authorized then logout
  // and redirect to login page
  if (response.status === 401) {
    dispatch("logout", null, { root: true });
    return Promise.reject(new Error('USER_ANONYMOUS'));
  }

  let err = new Error(response.statusText)
  err.response = response

  return Promise.reject(err)
}

const api = {
    namespaced: true,
    state: {
    },
    mutations: {
    },
    actions: {
        get(ctx, url) { 
            return axios({url: `/api/${url}`, method: "get" }).then((res) => {return checkResponse(ctx, res)})
        },
        post(ctx, {url, data}) { 
            return axios({url: `/api/${url}`, data: data, method: "post" }).then((res) => {return checkResponse(ctx, res)})
        }
    },
    getters: {
    },
    modules: {
    }
}

export default api;